import { createSlice } from '@reduxjs/toolkit'
import { pick } from 'lodash'
import * as Types from './types'
import { FormInstance } from 'antd-mobile/es/components/form'
import { AppDispatch, AppGetState, AppThunkDispatch } from '..'
import { SIZE } from '@/bizComponents/Parcel/constants'
import { setProps } from '@/store/serviceProviderSlice'
const initialState: Types.InitialState = {
  currencyInfo: null,
  props: {},
  errors: {},
}
const parcelSlice = createSlice({
  name: 'parcelSlice',
  initialState,
  reducers: {
    update(state, action) {
      return {
        ...state,
        ...action.payload,
        props: {
          ...state.props,
          ...action.payload?.props,
        },
      }
    },
    updateProps(state, action) {
      const { cover, ...props } = action.payload

      let updateProps = { ...(state?.props || {}), ...props }

      if (cover) {
        updateProps = props
      }

      return {
        ...state,
        props: updateProps,
      }
    },
    updateErrors(state, action) {
      return {
        ...state,
        errors: action.payload,
      }
    },
  },
})
export const { update, updateProps, updateErrors } = parcelSlice.actions

// 初始化parcel from
export const initParcelForm = (params?: Types.IInitialParcel) => async (dispatch: AppThunkDispatch, getState: AppGetState, form: FormInstance) => {
  try {
    const { formValues, props } = params || {}

    // 初始化props
    if (props) {
      await dispatch(initProps(props))
    }

    const state = getState()

    const { parcel: parcelSlice, dictionary } = state
    const {
      props: { arrivalCountry, originCurrencyCode },
    } = parcelSlice
    const arrivalCurrencyCode = dictionary?.countryMapDics?.[arrivalCountry]?.currency

    const { parcel_commodities: commodities } = formValues || {}
    // 新建无初始值
    const parcel = Array.isArray(commodities) ? commodities : []

    // 创建订单场景，没formValues参数，需要设长度单位和重量单位默认值
    const updateFormValues = Object.assign({}, formValues, {
      parcel_commodities: parcel,
      parcel_length_unit: formValues?.parcel_length_unit || SIZE.cm,
      parcel_weight_unit: formValues?.parcel_weight_unit || 'kg',
      parcel_currency_code: originCurrencyCode || arrivalCurrencyCode,
    })

    const finalFormValues = pick(
      updateFormValues,
      Object.keys(updateFormValues).filter((key) => key.startsWith('parcel_'))
    )

    form.setFieldsValue(finalFormValues)

    dispatch(updateProps({ isReady: !!parcel.length }))
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
  }
}

/** 初始化参数 */
export const initProps = (params: Types.IInitialParcel['props']) => async (dispatch: AppDispatch) => {
  const { senderCountry, arrivalCountry } = params
  /** 是否为跨境 */
  const isCrossBorder = arrivalCountry && senderCountry && arrivalCountry !== senderCountry
  /** 是否为中国跨境 */
  const isChinaCrossBorder = isCrossBorder && senderCountry === 'CN'
  /** 是否得力迅 */
  const isCN2US = senderCountry === 'CN' && arrivalCountry === 'US'
  /** 香港跨境 */
  const isHKCrossBorder = senderCountry === 'HK' && arrivalCountry !== 'HK'

  /** ID local */
  const IsIndonesia = senderCountry === 'ID' && arrivalCountry === 'ID'

  dispatch(updateProps({ ...params, isCrossBorder, isChinaCrossBorder, isCN2US, isHKCrossBorder, IsIndonesia }))
}
export const updateSenderCountry = (senderCountry: string) => async (dispatch: AppDispatch, getState: AppGetState, form: FormInstance) => {
  const state = getState()
  const { parcel: parcelSlice } = state
  const { arrivalCountry, orderType } = parcelSlice?.props ?? {}
  /** 是否为跨境 */
  const isCrossBorder = arrivalCountry && senderCountry && arrivalCountry !== senderCountry
  /** 是否为中国跨境 */
  const isChinaCrossBorder = isCrossBorder && senderCountry === 'CN'
  const isCN2US = senderCountry === 'CN' && arrivalCountry === 'US'
  /** 香港跨境 */
  const isHKCrossBorder = senderCountry === 'HK' && arrivalCountry !== 'HK'

  const IsIndonesia = senderCountry === 'ID' && arrivalCountry === 'ID'
  // 订单创建 收货国家才和包裹币种联动
  if (orderType === Types.ORDER_TYPE.ORDER_CREATE) {
    // 订单创建 收货国家才和包裹币种联动
    const { dictionary } = state
    const parcel_currency_code = dictionary?.countryMapDics?.[arrivalCountry]?.currency

    form.setFieldsValue({ parcel_currency_code })
    dispatch(
      setProps({
        currencyCode: parcel_currency_code,
        codCurrencyCode: parcel_currency_code, // 更新商品币种，COD币种跟商品币种保存一致
      })
    )
  }

  dispatch(updateProps({ isChinaCrossBorder, isCrossBorder, senderCountry, isCN2US, isHKCrossBorder, IsIndonesia }))
}

export const updateArrivalCountry = (arrivalCountry: string) => async (dispatch: AppDispatch, getState: AppGetState, form: FormInstance) => {
  const state = getState()
  const { parcel: parcelSlice } = state
  const { senderCountry, orderType } = parcelSlice?.props ?? {}
  /** 是否为跨境 */
  const isCrossBorder = arrivalCountry && senderCountry && arrivalCountry !== senderCountry
  /** 是否为中国跨境 */
  const isChinaCrossBorder = isCrossBorder && senderCountry === 'CN'
  const isCN2US = senderCountry === 'CN' && arrivalCountry === 'US'
  /** 香港跨境 */
  const isHKCrossBorder = senderCountry === 'HK' && arrivalCountry !== 'HK'

  const IsIndonesia = senderCountry === 'ID' && arrivalCountry === 'ID'
  // 订单创建 收货国家才和包裹币种联动
  if (orderType === Types.ORDER_TYPE.ORDER_CREATE) {
    // 订单创建 收货国家才和包裹币种联动
    const { dictionary } = state
    const parcel_currency_code = dictionary?.countryMapDics?.[arrivalCountry]?.currency

    form.setFieldsValue({ parcel_currency_code })
    dispatch(
      setProps({
        currencyCode: parcel_currency_code,
        codCurrencyCode: parcel_currency_code, // 更新商品币种，COD币种跟商品币种保存一致
      })
    )
  }

  dispatch(updateProps({ isChinaCrossBorder, isCrossBorder, arrivalCountry, isCN2US, isHKCrossBorder, IsIndonesia }))
}

/** 包裹校验信息 */
export const updateParcelErrors = (errors) => (dispatch: AppDispatch) => {
  const errs = errors?.errorFields?.filter((item) => item.name.includes('parcel_commodities'))
  const parcelFormItemsError = {}
  if (errs?.length) {
    errs.forEach((item) => {
      const index = item.name[1]
      // const key = item.name[2]
      const error = item['errors']
      parcelFormItemsError[index] = {
        errors: error,
      }
    })
  }

  dispatch(updateErrors(parcelFormItemsError))
}

export default parcelSlice.reducer
